import * as z from 'zod'
import { schemaBoolish } from './zodUtils.js'

export const feePutSchema = z.object({
    id: z.string().optional(),
    feeCash: z.coerce.string().nullish(),
    feeUnits: z.coerce.string().nullish(),
    feeBoth: schemaBoolish.nullish(),
    feeLevel: z.coerce.number().nullish(),
    topDown: schemaBoolish.nullish(),
    middleDown: z.coerce.string().nullish(),
})
